export default __webpack_public_path__ + "static/media/center-small.7e21d847.svg";